export default __webpack_public_path__ + "static/media/vegan-products-in-coffee-shops.73a739fb.png";